import { queryClient } from '~/lib/query-client'
import { serviceLevelKey } from '~/resources/service-level'

// focus-challenge opens the Plus paywall in-place (location.href) and the paywall
// returns via history.back() (see ADR 0039). On WebViews that restore from the
// back/forward cache on back navigation (iOS WKWebView), the page's JS resumes
// from a frozen snapshot: Solid never re-mounts and the service-level query
// (staleTime: Infinity) never auto-refetches, so a just-subscribed user comes
// back to a stale non-subscriber entitlement and gets re-routed to the paywall.
//
// `pageshow` with `event.persisted === true` fires exactly on a bfcache restore,
// so refreshing the entitlement query there is precisely scoped — no effect on a
// normal forward load (persisted === false) or on WebViews that reload on back
// (Android).
//
// We resetQueries rather than invalidateQueries: invalidate keeps the previous
// (stale, non-subscriber) data while refetching in the background, so a tap that
// races the in-flight refetch still reads `{ status: 'success', inSubscription:
// false }` and decidePlusTap re-routes to the paywall. reset clears the query
// to its initial 'pending' state and then refetches the active observer, so a
// racing tap reads 'pending' and decidePlusTap awaits the refetch before
// deciding (see ~/lib/plus-claim + page.tsx handlePlusTap). Service-level is
// only read on a Plus card tap, never rendered, so the cleared state causes no
// flicker. Tracked in issue #205.
export function revalidateEntitlementOnBfcacheRestore(): void {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      void queryClient.resetQueries({ queryKey: serviceLevelKey })
    }
  })
}
